import { Component, inject } from '@angular/core';
import { ToolbarComponent } from '../../../shared/components/toolbar/toolbar.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ICategory } from '../../model/category.model';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { IUser } from '../../../user/model/user.model';
import { CategoryService } from '../../services/category.service';
import { Location } from '@angular/common';
import { ToastService } from '../../../shared/services/toast.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'clp-details-category',
    styleUrls: ['./categoryDetails.component.scss'],
    templateUrl: './categoryDetails.component.html',
    imports: [
    ToolbarComponent,
    RouterModule,
    TranslateModule,
    ReactiveFormsModule
],
    providers: [
        CategoryService,
        ToastrService
    ]
})

export class CategoryDetailsComponent {
    private _location = inject(Location);
    private categoryService = inject(CategoryService);
    private toastService = inject(ToastService);
    private translate = inject(TranslateService);
    private router = inject(Router);
    private route = inject(ActivatedRoute);

    categoryForm!: FormGroup;
    category$!: Observable<ICategory>;
    id!: string | null;
    edit: boolean = false;
    user$!: Observable<IUser>;

    ngOnInit(): void {     
        this.id = this.route.snapshot.paramMap.get('id');
        if (this.id !== undefined && this.id !== null && this.id !== '') {
            this.edit = true;
        }        
        
        this.categoryForm = new FormGroup({
            id: new FormControl(''),
            name: new FormControl('', [Validators.maxLength(65)])
        });      

        if (this.id !== null) {                      
            this.categoryService.getCategory(this.id).subscribe(category => {
                this.id = category.id ?? null;
                this.categoryForm.controls['name'].setValue(category.name);
            });
        }
    }

    changeCategory(formValues: any) {
        if (!this.categoryForm.invalid) {      
            const category = {
                id: this.id,
                name: formValues.name                
            } as ICategory;   

            var return$: Observable<ICategory>;
            if (this.id === undefined || this.id === null)
                return$ = this.categoryService.createCategory(category);
            else
                return$ = this.categoryService.editCategory(category);

            return$.subscribe(category => {
                if (category !== undefined && category !== null && category.id !== null) {                
                    let message = "category.create.successMessage";
                    if (this.id !== undefined && this.id !== null)
                        message = "category.update.successMessage";
        
                    this.toastService.show(this.translate.instant(message), "");
                    this.router.navigate(['listCategories']);
                }
            })
        }
    }

    backClicked() {
        this._location.back();
    }       
}
